module.exports = __webpack_public_path__ + "static/img/about_h5bg_11_zh.6788b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_11_zh.png
// module id = yTRw
// module chunks = 34